
import Vue from 'vue'
import Doc from '../components/Doc/Doc.vue'

export default Vue.extend({
  name: 'Notes',

  components: {
    Doc
  }
})
